module.exports = __webpack_public_path__ + "static/media/EnCORE_consent_EN_p3.a559eb96.jpg";